/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Card_Plan_DescInputs */

const en_landing_card_plan_desc = /** @type {(inputs: Landing_Card_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn an idea into a PRD, feature specs and tasks your AI coding agent can pick up.`)
};

const id_landing_card_plan_desc = /** @type {(inputs: Landing_Card_Plan_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah ide jadi PRD, spesifikasi fitur, dan task yang siap diambil AI coding agent kamu.`)
};

/**
* | output |
* | --- |
* | "Turn an idea into a PRD, feature specs and tasks your AI coding agent can pick up." |
*
* @param {Landing_Card_Plan_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_card_plan_desc = /** @type {((inputs?: Landing_Card_Plan_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Card_Plan_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_card_plan_desc(inputs)
	return en_landing_card_plan_desc(inputs)
});